
import React from 'react';
import { NavLink } from 'react-router-dom';
import { NAV_ITEMS } from '../../constants';
import { cn } from '../../lib/utils';
import { useData } from '../../hooks/useData';
import { dataManager } from '../../utils/dataManager';

const Navigation: React.FC = () => {
  const theme = useData(() => dataManager.getTheme());
  const isLight = theme === 'light';

  return (
    <nav className="w-full">
      <div className="glass-nav bg-kfppc-surface/98 backdrop-blur-2xl rounded-2xl flex justify-around items-center h-16 px-1 border border-white/10 mx-4 mb-4 md:m-0 shadow-[0_10px_40px_-10px_rgba(0,0,0,0.7)]">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            title={item.label}
            className={({ isActive }) => cn(
              "flex flex-col items-center justify-center w-full h-full space-y-0.5 transition-all duration-300 rounded-xl relative",
              isActive ? "text-[#FFFFFF]" : "text-kfppc-lavender/50 hover:text-kfppc-lavender"
            )}
          >
            {({ isActive }) => (
              <>
                 <div className={cn(
                   "p-1.5 rounded-full transition-all duration-300",
                   isActive 
                     ? (isLight ? "bg-white text-kfppc-royal shadow-lg translate-y-[-4px]" : "bg-kfppc-royal text-[#FFFFFF] shadow-[0_0_15px_rgba(59,130,246,0.6)] translate-y-[-4px]")
                     : ""
                 )}>
                    <item.icon 
                      size={20} 
                      strokeWidth={isActive ? 2.5 : 2}
                      className={isActive ? "fill-current/20" : ""}
                    />
                 </div>
                 <span className={cn(
                   "text-[10px] font-bold uppercase tracking-wide transition-all text-center leading-none max-w-[64px] truncate px-1",
                   isActive ? "opacity-100 translate-y-[-2px]" : "opacity-0 scale-0 absolute -bottom-2",
                   item.label === 'Tournament History' && "hidden" // Icon-only for Tournament History
                 )}>
                   {/* Smart truncation/renaming for mobile fitting */}
                   {item.label === 'Tournament History' ? '' : 
                    item.label === 'Player Rankings' ? 'Rank' :
                    item.label === 'Match History' ? 'Hist' :
                    item.label === 'Press Room' ? 'News' :
                    item.label === 'Settings' ? 'Admin' :
                    item.label === "Commissioner's Office" ? 'Office' :
                    item.label === "Dynamic Insights" ? 'Insights' :
                    item.label}
                 </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;
